import Vue from 'vue'

export const userKey = process.env.VUE_APP_USER_KEY
export const rutPregao = process.env.VUE_APP_PREGAO_API_URL
export const urlApi = process.env.VUE_APP_API_URL


export function showError(e, msgPersonalizada) {
    if (e && e.response && e.response.status == 401) {
        return
    }
    console.error('Erro capturado:', e);
    if (e && e.response && e.response.data) {
        Vue.toasted.global.defaultError({
            msg: e.response.data
        })
    } else if (typeof e === 'string') {
        Vue.toasted.global.defaultError({
            msg: e + (msgPersonalizada || '')
        })
    } else {
        Vue.toasted.global.defaultError()
    }
}

export default {
    urlApi,
    showError
}